import { observable } from "@legendapp/state"

interface FeaturebaseData {
  unreadCount: number
  isOpen: boolean
}

const initialState: FeaturebaseData = {
  unreadCount: 0,
  isOpen: false,
}

export const featurebaseStore$ = observable(initialState)
